import React, { useState, useContext } from 'react';
import { useAuth } from '../AuthContext';
import bcrypt from "bcryptjs";

import { useNavigate } from 'react-router-dom';

const LoginModal = ({ closeModal }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const { API_BASE_URL } = useAuth();

  const handleLogin = async () => {
    const salt = "$2a$10$1234567890123456789012";
    const pw = await bcrypt.hash(password, salt);
    fetch(API_BASE_URL + 'login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password: pw }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.token) {
          login(data.token); // Update the AuthContext with the new token
          closeModal(); // Close the login modal
          navigate('/alerts'); // Redirect to the default page after login
        } else {
          alert('Invalid credentials');
        }
      })
      .catch((err) => console.error(err));
  };

  return (
    <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Login</h5>
            <button type="button" className="btn-close" onClick={closeModal}></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">Username</label>
              <input
                type="text"
                className="form-control"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={handleLogin}>
              Login
            </button>
            <button className="btn btn-secondary" onClick={closeModal}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
